import { useDispatch } from "react-redux"
import TrainingSlice from "./slice"
import { useCallback } from "react"

export const {
	SetCursoColaboradorId,
	SetCursosActions,
	SetOpenPdf,
	Reload,
	ReloadCourses,
	Edit,
	SetExpanded
} = TrainingSlice.actions

export const UseReload = () => {
	const dispatch = useDispatch()
	const fn = useCallback(() => {
		dispatch(Reload())
	}, [dispatch])
	return fn
}
export const UseReloadCourses = () => {
	const dispatch = useDispatch()
	const fn = useCallback(() => {
		dispatch(ReloadCourses())
	}, [dispatch])
	return fn
}
export const UseSetCursoColaboradorId = () => {
	const dispatch = useDispatch()
	const fn = useCallback(
		(id) => {
			dispatch(SetCursoColaboradorId(id))
		},
		[dispatch]
	)
	return fn
}
export const UseSetEdit = () => {
	const dispatch = useDispatch()
	const fn = useCallback(
		(data) => {
			dispatch(Edit(data))
		},
		[dispatch]
	)
	return fn
}

export const UseSetCursosActions = () => {
	const dispatch = useDispatch()
	const fn = useCallback(
		(action) => {
			dispatch(SetCursosActions(action))
		},
		[dispatch]
	)
	return fn
}
export const UseSetExpanded = () => {
	const dispatch = useDispatch()
	const fn = useCallback(
		(action) => {
			dispatch(SetExpanded(action))
		},
		[dispatch]
	)
	return fn
}
export const UseSetOpenPdf = () => {
	const dispatch = useDispatch()
	const fn = useCallback(
		(action) => {
			dispatch(SetOpenPdf(action))
		},
		[dispatch]
	)
	return fn
}
